import React, { Suspense } from 'react';
import Navbar from "@/components/Navbar";
import VideoHero from "@/components/VideoHero";

import WelcomeSection from "@/components/WelcomeSection";
import ExpertiseShowcase from "@/components/ExpertiseShowcase";
import WorkProcessSlider from "@/components/WorkProcessSlider";
import ValuePropositions from "@/components/ValuePropositions";
import ExpertiseCards from "@/components/ExpertiseCards";
import ChiptuningLookup from "@/components/ChiptuningLookup";
import ReviewsCarousel from "@/components/ReviewsCarousel";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";


const Index = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <main>
        <Suspense fallback={
          <div className="w-full h-screen bg-black flex items-center justify-center">
            <div className="text-white text-xl">Loading...</div>
          </div>
        }>
          <VideoHero />
        </Suspense>
        <WelcomeSection />
        <ChiptuningLookup />
        <ExpertiseShowcase />
        <WorkProcessSlider />
        <ValuePropositions />
        <ExpertiseCards />
        <ReviewsCarousel />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
